import { testimonials } from "@/mocks/testimonials";

export default function Testimonials() {
  return (
    <section className="py-10 md:py-14 bg-background-100/70">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">用户口碑</h2>
            <p className="text-sm text-foreground-500 mt-2">听听我们的读者怎么说</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {testimonials.map((t) => (
              <div
                key={t.id}
                className="p-5 bg-background-50 rounded-xl border border-background-200/70"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
                <div className="flex items-center gap-0.5 mb-2">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-xs ${
                        i < t.rating ? "text-accent-500" : "text-foreground-200"
                      }`}
                    ></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}